import decode, { JwtPayload } from 'jwt-decode';
import { apiService } from '../../services/api';
import { Credential } from '../../dto';
import { Dispatch } from '../types';
import { User } from '../types';

export const LOCAL_STORAGE_KEY = 'accessToken';
export const LOGIN_SUCCESS = 'LOGIN_SUCCESS';
export const LOGOUT_SUCCESS = 'LOGOUT_SUCCESS';
export const RESUME_SESSION_SUCCESS = 'LOGOUT_SUCCESS';

export interface DecodedToken extends JwtPayload {
  role: string;
}

export function getRole(): string | null {
  const accessToken = window.localStorage.getItem(LOCAL_STORAGE_KEY);
  if (accessToken) {
    const { role }: DecodedToken = decode(accessToken);
    return role
  }
  return null;
}

export function isAdminRole(): boolean {
  return getRole() === 'admin';
}

export function getToken(): string | null {
  if (window) {
    return window.localStorage.getItem(LOCAL_STORAGE_KEY);
  }
  return null;
}

export function setToken(token: string): void {
  if (window) {
    window.localStorage.setItem(LOCAL_STORAGE_KEY, token);
  }
}

export async function getUserInfo(): Promise<User> {
  try {
    const path = '/customer/info';
    const { data } = await apiService({
      method: 'get',
      path,
    });

    if (data && data.success) {
    }
    return {} as User;
  } catch (err: any) {
    return Promise.reject(err?.response?.data);
  }
}

export const login = (dispatch: Dispatch) => async (params: Credential): Promise<User> => {
  try {
    const path = '/auth/login';
    const { data } = await apiService({
      method: 'post',
      path,
      data: params,
      isPublic: true,
    });

    if (data && data.success) {
      const { accessToken } = data.data || {};
      if (accessToken && window) {
        window.localStorage.setItem('accessToken', accessToken);
        dispatch({ type: LOGIN_SUCCESS, accessToken });
      }
      return data.data.user;
    } else {
      const { message, code } = data;
      if (code === '1110') {
        throw new Error('Invalid email or password')
      }
      throw new Error(`Login failed: ${message}`)
    }
  } catch (err: any) {
    return Promise.reject(err?.response?.data);
  }
}

export const logout = (dispatch: Dispatch) => async (): Promise<void> => {
  try {
    if (window) {
      window.localStorage.removeItem(LOCAL_STORAGE_KEY);
    }
    dispatch({ type: LOGOUT_SUCCESS });
  } catch (err) {
    console.error(err);
    return Promise.reject(err);
  }
}

export const resumeSession = (dispatch: Dispatch) => async (): Promise<void> => {
  const accessToken = window.localStorage.getItem(LOCAL_STORAGE_KEY);
  const currentTime = +new Date() / 1000;

  if (accessToken) {
    try {
      const { exp }: JwtPayload = decode(accessToken);

      if (exp && currentTime >= exp) {
        throw new Error('[Auth] Token expired.');
      }

      setToken(accessToken);
      dispatch({ type: RESUME_SESSION_SUCCESS, accessToken });
    } catch (err) {
      // remove invaild token
      window.localStorage.removeItem(LOCAL_STORAGE_KEY);
    }
  }
};
